import Link from 'next/link';

import FooterBackground from '@/assets/footer-m.svg';
import Container from '@/components/elements/Container';
import FooterColumn from '@/components/elements/FooterColumn';
import Section from '@/components/elements/Section';
import StoryblokLink from '@/components/elements/StoryblokLink';
import SocialMedia from '@/components/richtext/SocialIcons';
import AppConfig from '@/utils/AppConfig';

export interface NewsletterFooterProps {
  action: string;
}

export default function Footer({ settingsFooter }) {
  const date = new Date();
  return (
    <Section
      id="footer"
      className="dark relative z-40 bg-theme-darkgrey"
      aria-labelledby="footer-heading"
      element="footer"
      gapBottom="none"
      gapTop="none"
      padTop="none"
      padBottom="none"
    >
      <div
        className="flex flex-col py-16 md:grid"
        style={{
          backgroundImage: `url(${FooterBackground.src})`,
        }}
      >
        <Container size="widest" className="pb-6 lg:pb-16">
          <div className={`gap-12 lg:grid lg:grid-cols-[1fr_4fr]`}>
            <div className="h-24">
              <Link href="/">
                <svg
                  className={'dark mr-8 block h-full text-white'}
                  viewBox="0 0 843 636"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M668.136 436.448C624.633 436.447 581.129 436.52 537.625 436.417C513.807 436.362 504.807 429.911 497.503 407.255C481.559 357.798 465.938 308.238 449.99 258.783C445.55 245.016 447.286 233.072 455.885 220.945C503.052 154.423 549.829 87.6256 596.459 20.7237C605.802 7.31814 617.137 0.136131 634.131 0.872024C655.573 1.79959 677.087 1.06102 698.571 1.10391C722.442 1.15217 730.115 6.6345 736.877 29.3144C762.589 115.564 788.218 201.838 813.77 288.135C822.287 316.898 830.81 345.667 838.637 374.62C841.257 384.316 842.618 394.564 842.966 404.615C843.511 420.341 837.466 428.783 822.428 432.953C813.77 435.353 804.455 436.231 795.423 436.301C752.997 436.634 710.566 436.449 668.136 436.448Z"
                    fill="#E71D21"
                  />
                  <path
                    d="M393.839 224.169C345.315 154.789 296.718 85.4608 247.989 16.2238C240.421 5.47098 229.992 0.350563 216.309 0.709796C193.251 1.31567 170.164 0.837144 147.09 0.8854C124.397 0.930974 116.873 6.44682 110.267 28.5303C86.6858 107.339 63.2487 186.189 39.7071 265.009C29.7701 298.277 19.7467 331.52 9.74701 364.769C6.02734 377.135 0.88818 389.387 0.0729302 402.408C-0.227094 407.202 0.361435 412.152 2.53281 416.438C6.31008 423.897 14.416 429.462 21.9595 432.599C30.1885 436.019 39.1976 437.021 48.0444 437.008C136.051 436.889 224.056 437.022 312.063 436.911C332.169 436.886 342.338 430.465 348.442 411.756C365.678 358.932 382.022 305.817 399.031 252.916C402.518 242.067 399.875 232.799 393.839 224.169Z"
                    fill="currentColor"
                  />
                  <path
                    d="M281.545 569.907C281.775 546.11 267.105 530.852 243.705 530.546C220.105 530.237 203.525 546.631 203.795 570.01C204.055 592.552 220.875 609.381 243.005 609.227C265.785 609.07 281.335 593.21 281.545 569.907ZM243.145 635.2C202.305 635.263 174.285 608.95 174.075 570.355C173.865 530.794 201.965 503.466 242.905 503.428C283.785 503.392 312.505 530.998 312.215 570.055C311.935 608.542 283.735 635.138 243.145 635.2Z"
                    fill="currentColor"
                  />
                  <path
                    d="M560.095 519.725C552.765 527.551 546.695 534.03 539.935 541.237C527.645 531.285 513.745 527.726 499.205 531.61C491.885 533.562 484.335 537.947 479.055 543.283C466.825 555.651 466.785 580.494 477.445 594.425C486.745 606.579 507.265 615.233 533.665 602.914V583.035H512.975V557.793H561.415V623.685C531.965 636.699 501.175 642.107 470.365 625.464C446.855 612.769 438.135 590.718 439.565 565.635C441.185 536.874 455.735 515.578 484.745 507.019C510.975 499.282 536.135 502.298 560.095 519.725Z"
                    fill="currentColor"
                  />
                  <path
                    d="M360.315 556.958C369.985 556.958 377.845 557.155 385.695 556.902C393.375 556.654 397.095 552.259 397.295 544.909C397.505 537.414 393.205 532.882 386.165 532.17C377.945 531.339 369.575 531.976 360.315 531.976V556.958ZM330.495 507.382C353.375 507.382 375.295 506.8 396.785 509.03C415.745 510.994 425.325 522.275 427.825 538.054C430.605 555.539 423.565 568.947 406.855 578.098C405.525 578.828 404.245 579.657 402.145 580.915C411.975 597.188 421.685 613.262 432.345 630.926H398.175C389.925 615.694 372.215 583.035 372.215 583.035H359.395V631.488H330.495V507.382Z"
                    fill="currentColor"
                  />
                  <path
                    d="M624.785 581.039H653.525C648.735 569.346 644.385 558.713 638.895 545.298C633.565 558.809 629.415 569.326 624.785 581.039ZM651.705 507.099C670.025 548.283 688.055 588.834 706.815 631.013H674.705C671.135 623.126 667.525 615.137 663.815 606.939H615.175C611.565 615.094 608.175 622.719 604.425 631.164H573.045C591.525 589.315 609.665 548.216 627.825 507.099H651.705Z"
                    fill="currentColor"
                  />
                  <path
                    d="M154.035 507.095V630.763H126.915V539.663C116.005 570.275 105.065 600.687 94.085 631.407H72.245C69.605 623.826 42.041 544.778 40.364 539.922V631.364H12V507.997H54.696C63.575 532.069 72.895 557.3 82.205 582.574C83.185 582.661 84.135 582.704 85.125 582.79C94.475 557.558 103.825 532.326 113.185 507.095H154.035Z"
                    fill="currentColor"
                  />
                  <path
                    d="M839.325 507.91V631.063H802.415C787.185 606.992 771.385 582.016 755.565 556.957L747.705 544.555V630.978H719.985V507.395H757.865C772.505 530.695 787.575 554.682 802.725 578.755L808.375 587.768L810.575 591.242V507.91H839.325Z"
                    fill="currentColor"
                  />
                </svg>
              </Link>
            </div>
            <div className="mt-6 grow gap-16 md:mt-0 md:grid-cols-2 lg:grid lg:grid-cols-[1fr_1fr_1fr_1fr]">
              {settingsFooter.navigationColumns.map((c) => (
                <FooterColumn key={c._uid} {...c} />
              ))}
            </div>
          </div>
        </Container>
        <Container size="widest">
          <div className="grid place-content-center gap-6 align-middle lg:grid-cols-3 lg:gap-16">
            <p className="self-center text-xs">
              &copy; {date.getFullYear()} {AppConfig.site_name}. All rights
              reserved.
            </p>
            <div className="m-auto">
              <SocialMedia />
            </div>

            <div className="flex justify-center gap-4 self-center text-xs lg:justify-end lg:text-right">
              {settingsFooter.navigationLegal.map((v) => {
                return (
                  <StoryblokLink key={v._uid} link={v.url}>
                    <span className="max-w-48 cursor-pointer hover:text-theme-primary">
                      {v.label}
                    </span>
                  </StoryblokLink>
                );
              })}
            </div>
          </div>
        </Container>
      </div>
    </Section>
  );
}
